<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="IsQy"
          sortable="IsQy"
          label="状态/编号"
          align="center"
          :formatter="
            (row) => $tab_GroupFormat(row.Zt?.Text, row.Bh, row.Zt?.Color)
          "
        />
        <el-table-column
          prop="Lx"
          width="90"
          label="类型"
          :formatter="$tab_StatusFormat"
        />
        <el-table-column prop="Cjsj" sortable="Cjsj" label="申请时间" width="180" />
        <el-table-column prop="CjrXm" label="申请人" />
        <el-table-column
          prop="Yfje"
          sortable="Yfje"
          label="应付(元)"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="Zje"
          sortable="Zje"
          label="本次申请额(元)"
          align="center"
        >
          <template #default="{ row }">
            <span style="color: #f56c6c; font-weight: 600">{{ $priceFormat(row.Zje) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Fkje"
          sortable="Fkje"
          label="已付(元)"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column prop="Bz" label="备注" :formatter="$tab_TextFormat" />
        <el-table-column
          label="操作"
          width="280"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Search"
              link
              @click="
                $store.commit('openMenu', {
                  path: 'DuiZhangDanSearch',
                  title: '对账单详情',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              >查看
            </el-button>
            <el-button
              type="primary"
              :icon="Check"
              link
              v-if="row.IsSh"
              @click="
                $store.commit('openMenu', {
                  path: 'DuiZhangDanFkDetail',
                  title: '对账单详情',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              >审核
            </el-button>
            <el-button
              type="warning"
              :icon="Money"
              link
              v-if="row.Zt?.Key == 4 || row.Zt?.Key == 6"
              @click="
                $store.commit('openMenu', {
                  path: 'DuiZhangDanFkDetail',
                  title: '对账单详情',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              >付款
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { duizhangdan_list, gongyingshang_delete } from "@/http/api";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  setup() {
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: {
          Zt: 2,
          TableName: "DuiZhangDan_Fk",
        },
        Order: "Cjsj",
        Asc: false,
      },
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      duizhangdan_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //打开内容页
    const onOpenCompile = (id) => {
      state.compileTitle = id ? "修改" : "添加";
      state.selectId = id;
      state.showCompile = true;
    };

    //关闭内容页
    const onCloseCompile = (refresh) => {
      state.showCompile = false;
      if (refresh) {
        onLoad();
      }
    };

    //排序
    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Cjsj",
          Asc: false,
        },
      });
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      ElMessageBox.confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        gongyingshang_delete(id).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert("删除成功", "提示", {
              type: "success",
              callback: () => {
                onLoad();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    const onShowAuthorize = (id) => {
      state.key = Math.random();
      state.showAuthorize = true;
      state.selectId = id;
    };

    const onShowUser = (id) => {
      state.showUser = true;
      state.selectId = id;
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onCloseCompile,
      onOpenCompile,
      onDelete,
      onShowAuthorize,
      onShowUser,
    };
  },
};
</script>
<style>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>
